import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import all translation files
import enTranslation from './locales/en.json';
import frTranslation from './locales/fr.json';
import nlTranslation from './locales/nl.json';
import esTranslation from './locales/es.json';
import deTranslation from './locales/de.json';
import thTranslation from './locales/th.json';
import itTranslation from './locales/it.json';
import ptTranslation from './locales/pt.json';
import daTranslation from './locales/da.json';
import svTranslation from './locales/sv.json';

// Type-safe translation resources
const resources = {
  en: { translation: enTranslation },
  fr: { translation: frTranslation },
  nl: { translation: nlTranslation },
  es: { translation: esTranslation },
  de: { translation: deTranslation },
  th: { translation: thTranslation },
  it: { translation: itTranslation },
  pt: { translation: ptTranslation },
  da: { translation: daTranslation },
  sv: { translation: svTranslation },
} as const;

// Language configuration
export const supportedLanguages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'th', name: 'ไทย', flag: '🇹🇭' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
  { code: 'da', name: 'Dansk', flag: '🇩🇰' },
  { code: 'sv', name: 'Svenska', flag: '🇸🇪' },
];

// Get browser language
export const getBrowserLanguage = (): string => {
  if (typeof window !== 'undefined') {
    const browserLang = navigator.language.split('-')[0];
    const supported = supportedLanguages.find(lang => lang.code === browserLang);
    return supported ? browserLang : 'en';
  }
  return 'en';
};

// Initialize i18next
i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // React already escapes
    },
    // Disable automatic detection for now to ensure consistent behavior
    supportedLngs: ['en', 'fr', 'nl', 'es', 'de', 'th', 'it', 'pt', 'da', 'sv'],
    nonExplicitSupportedLngs: false,
  })
  .then(() => {
    // After initialization, try to detect browser language
    if (typeof window !== 'undefined') {
      const browserLang = navigator.language.split('-')[0];
      const supported = ['en', 'fr', 'nl', 'es', 'de', 'th', 'it', 'pt', 'da', 'sv'].includes(browserLang);
      if (supported && browserLang !== 'en') {
        i18n.changeLanguage(browserLang);
      }
    }
  });

export default i18n;
